export default "__VITE_ASSET__b9828626__"